/**  */

// eslint-disable-next-line
import React from 'react';
import { ChevronRightOutlined, ChevronLeftOutlined } from '@material-ui/icons';
import { Container, Row, Col } from 'react-grid-system';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import Slider from 'react-slick';
import Img from 'react-image';

// Assets
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Vars
import { themeVars } from '../../config/styles';

const cssArrow = css`
  font-size: 4.8rem !important;
  color: #000;
  display: block;
  transition: 250ms ease-in-out all;

  &:hover {
    color: ${themeVars.root.secondary};
  }
`;

const cssArrowLeft = css`
  position: absolute;
  left: -20px;
  bottom: -64px;
  cursor: pointer;
  z-index: 10;
`;

const cssArrowRight = css`
  position: absolute;
  left: 30px;
  bottom: -64px;
  cursor: pointer;
  z-index: 10;
`;

const cssSlide = css`
  cursor: pointer;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    margin: 0;
  }
`;

const HeroImageSlider = ({ imageSliderImages, imageSlider }) => {
  const cssSliderWrapper = css`
    background-color: #e6ecef;
    ${imageSlider && `padding-bottom: 25px`};
  `;

  const cssWrapper = css`
    line-height: 0;
    display: block;
    clear: both;
    top: -60px;

    .slick-dots {
      position: absolute;
      left: 90px;
      width: auto;
      bottom: -52px;

      & > li {
        &:hover {
          .hexagon {
            background-color: ${themeVars.root.primary};
          }

          .hexagon:before {
            border-bottom: 3.46px solid ${themeVars.root.primary};
          }

          .hexagon:after {
            border-top: 3.46px solid ${themeVars.root.primary};
          }
        }
      }
    }

    .hexagon {
      position: relative;
      width: 12px;
      height: 6.93px;
      background-color: #b1b9bf;
      margin: 3.46px 0;
    }

    .hexagon:before,
    .hexagon:after {
      content: '';
      position: absolute;
      width: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      left: 0; /* Fix for placement */
    }

    .hexagon:before {
      bottom: 100%;
      border-bottom: 3.46px solid #b1b9bf;
    }

    .hexagon:after {
      top: 100%;
      width: 0;
      border-top: 3.46px solid #b1b9bf;
    }

    .slick-active {
      .hexagon {
        background-color: ${themeVars.root.primary};
      }

      .hexagon:before {
        border-bottom: 3.46px solid ${themeVars.root.primary};
      }

      .hexagon:after {
        border-top: 3.46px solid ${themeVars.root.primary};
      }
    }
  `;

  function CustomLeftArrow({ onClick }) {
    return (
      <div css={cssArrowLeft}>
        <ChevronLeftOutlined css={cssArrow} onClick={onClick} />
      </div>
    );
  }

  function CustomRightArrow({ onClick }) {
    return (
      <div css={cssArrowRight}>
        <ChevronRightOutlined css={cssArrow} onClick={onClick} />
      </div>
    );
  }

  const settings = {
    arrows: true,
    autoplay: false,
    customPaging: () => <div className="hexagon" />,
    dots: true,
    draggable: false,
    infinite: true,
    nextArrow: <CustomRightArrow />,
    prevArrow: <CustomLeftArrow />,
    slidesToScroll: 1,
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1259,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section css={cssSliderWrapper}>
      <Container>
        <Row>
          <Col>
            <Slider {...settings} css={cssWrapper}>
              {imageSlider &&
                imageSliderImages.map((slide) => {
                  return (
                    <div css={cssSlide} key={shortid.generate()}>
                      <Img src={slide.image.sizes.hero_slider} alt="" />
                    </div>
                  );
                })}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

HeroImageSlider.defaultProps = {
  onClick: () => null,
  imageSlider: null,
  imageSliderImages: null,
};

HeroImageSlider.propTypes = {
  onClick: PropTypes.func,
  imageSlider: PropTypes.bool,
  imageSliderImages: PropTypes.arrayOf(PropTypes.shape()),
};

export default HeroImageSlider;
